import React from 'react';

/** The outline ring used for citations in an answer and for the number on a source card. */
export const chipClass =
  'inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full border border-peach px-1 align-middle text-micro text-peach transition-colors';

/** Renders paragraphs and turns [n] markers into clickable citation chips. */
export const AnswerText: React.FC<{
  text: string;
  onCite?: (n: number) => void;
}> = ({ text, onCite }) => {
  const paragraphs = text.split(/\n{2,}/).filter((p) => p.trim() !== '');
  return (
    <>
      {paragraphs.map((p, i) => (
        <p key={i} className="whitespace-pre-line">
          {p.split(/(\[\d+\])/g).map((part, j) => {
            const m = part.match(/^\[(\d+)\]$/);
            if (!m || !onCite)
              return <React.Fragment key={j}>{part}</React.Fragment>;
            const n = Number(m[1]);
            return (
              <button
                key={j}
                type="button"
                onClick={() => onCite(n)}
                aria-label={`Show source ${n}`}
                className={`${chipClass} mx-0.5 -translate-y-0.5 hover:bg-peach hover:text-navy`}
              >
                {n}
              </button>
            );
          })}
        </p>
      ))}
    </>
  );
};
